<template>
  <div>
    <h2 class="secondary-title" :class="{'secondary-title--container': withContainer}">{{ title }}<span>{{ subtitle }}</span></h2>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'WithTitle',
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    withContainer: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="sass">

.secondary-title
  font-size: 18px
  font-weight: 500
  margin: 0 0 20px

  +mmin($tablet)
    font-size: 24px

  &--container
    max-width: 1430px
    padding: 0 15px
    margin: 0 auto

  span
    margin-left: 10px
    color: #ccc

</style>
